import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { Subject } from 'rxjs';

type ThirdPartyProvider = 'google' | 'apple' | 'facebook';

interface CookieConsent {
  technical: true;
  providers: Record<ThirdPartyProvider, boolean>;
}

const COOKIE_CONSENT_KEY = 'cookie_consent';

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  // Subject used to request opening the cookie config panel from any component
  private openConfigSubject = new Subject<void>();
  openConfig$ = this.openConfigSubject.asObservable();

  constructor() {}

  async getStoredConsent(): Promise<CookieConsent | null> {
    try {
      const { value } = await Preferences.get({ key: COOKIE_CONSENT_KEY });
      if (!value) return null;
      return JSON.parse(value) as CookieConsent;
    } catch (e) {
      return null;
    }
  }

  async hasProviderConsent(provider: ThirdPartyProvider): Promise<boolean> {
    try {
      const stored = await this.getStoredConsent();
      if (!stored) return false;
      return !!stored.providers?.[provider];
    } catch (e) {
      return false;
    }
  }

  async persistConsent(consent: CookieConsent): Promise<void> {
    try {
      await Preferences.set({ key: COOKIE_CONSENT_KEY, value: JSON.stringify(consent) });
    } catch (e) {
    }
  }

  requestOpenConfig() {
    this.openConfigSubject.next();
  }
}
